import React, { useContext } from 'react';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import GlobalStyle from '../styles/GlobalStyle';
import Header from './Header';
import FeaturedLogos from './FeaturedLogos';
import Footer from './Footer';
import Cart from './Cart';
import NewsletterSignupPopup from './NewsletterSignupPopup';
import { StoreContext } from '../context/StoreContext';

const Layout = ({
  title,
  description,
  service,
  sitewideNotices,
  isHomepage,
  children,
}) => {
  const {
    datoCmsSite: { faviconMetaTags },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      datoCmsSite {
        faviconMetaTags {
          ...GatsbyDatoCmsFaviconMetaTags
        }
      }
    }
  `);

  const {
    serviceType,
    service: serviceAreaServed,
    name: serviceName,
    description: serviceDescription,
  } = service || {};

  const { isOverlayActive } = useContext(StoreContext);
  const siteUrl = process.env.GATSBY_SITE_URL;
  const location = useLocation();
  const pageUrl = `${siteUrl}${location.pathname}`;

  const schema =
    title && description
      ? {
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'WebPage',
              '@id': `${pageUrl}#webpage`,
              url: pageUrl,
              name: title,
              description: description,
              isPartOf: {
                '@id': `${siteUrl}/#website`,
              },
              ...(serviceType && {
                mainEntity: {
                  '@id': `${pageUrl}#service`,
                },
              }),
            },
          ],
        }
      : null;

  if (schema && serviceType) {
    const serviceSchema = {
      '@type': 'Service',
      '@id': `${pageUrl}#service`,
      name: serviceName || serviceType,
      description: serviceDescription || description,
      url: pageUrl,
      provider: {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: 'Root Houseplants',
        url: siteUrl,
      },
      areaServed: serviceAreaServed
        ? JSON.parse(serviceAreaServed).map(city => ({
            '@type': 'City',
            name: city,
          }))
        : {
            '@type': 'Country',
            name: 'United Kingdom',
          },
      serviceType,
    };

    schema['@graph'].push(serviceSchema);
  }

  return (
    <>
      <HelmetDatoCms favicon={faviconMetaTags}>
        <html lang="en-GB" />
        <meta
          name="google-site-verification"
          content="sQrqqXrVOlXzXtR-j0Zg0awZwlGSwTUQxdd8sThVhSI"
        />
        <script
          crossorigin
          defer
          type="module"
          data-qbud
          data-host="api.qbud.ai"
          data-color="rgb(5, 130, 103)"
          data-assistant-id="528bfdad-c20b-4cb1-9eb4-b8d7889ab556"
          src="https://app.qbud.ai/cdn/qbud.js"
        />
        <link
          rel="stylesheet"
          crossorigin
          href="https://app.qbud.ai/cdn/qbud.css"
        />
        {schema && (
          <script type="application/ld+json">
            {JSON.stringify(schema, null, 2)}
          </script>
        )}
      </HelmetDatoCms>
      <GlobalStyle isOverlayActive={isOverlayActive} />
      <Header sitewideNotices={sitewideNotices} />
      {children}
      {!isHomepage && <FeaturedLogos />}
      <Footer />
      <Cart />
      <NewsletterSignupPopup />
    </>
  );
};

export default Layout;
